<template lang="pug">
aside(:style="{'width': size, 'height': size }")
</template>

<script>
export default {
  name: 'Spacer',
  props: {
    size: {
      type: String,
      default: '0px',
      required: false,
    },
  },
};
</script>
